import React from 'react';
import { AlertTriangle, Loader2 } from 'lucide-react';
import { rechtFehlerText } from '../../services/rechte/rechtFehler';

// Gemeinsame Huelle der Cockpit-Karten: Ladeanzeige, Fehlermeldung, Leerfall
// oder Inhalt.
//
// Bewusst eine EIGENE Datei und nicht ein Export aus ErpCockpit.tsx: der
// Container importiert alle sechs Karten, jede Karte braucht diese Huelle —
// ein Export aus dem Container hinein waere ein Importzyklus. Er funktionierte
// heute (die Referenz faellt erst beim Rendern an), waere aber genau die Sorte
// Abhaengigkeit, die beim naechsten Umbau als „cannot access before
// initialization" hochgeht.

interface Props {
    laedt: boolean;
    fehler: string | null;
    leer?: boolean;
    leerText?: string;
    children: React.ReactNode;
}

export const KartenRahmen: React.FC<Props> = ({ laedt, fehler, leer, leerText, children }) => {
    if (laedt) {
        return (
            <div className="flex items-center justify-center gap-2 py-16 text-slate-400">
                <Loader2 className="w-5 h-5 animate-spin" /> Daten werden geladen…
            </div>
        );
    }
    if (fehler) {
        // Rollensystem (Nr. 153): die ERP-Funktionen melden ein fehlendes Recht
        // als `…: fehlendes Recht erp.steuerung`. Der Text kommt hier schon als
        // Zeichenkette an (useErpCockpit) — der Satz steht trotzdem darin.
        const recht = rechtFehlerText({ message: fehler });
        return (
            <div className="flex gap-3 p-4 bg-amber-50 border border-amber-200 rounded-xl text-sm text-amber-800">
                <AlertTriangle className="w-5 h-5 shrink-0 mt-0.5" />
                <div>
                    <p className="font-semibold">Auswertung nicht verfügbar</p>
                    <p className="mt-1">{recht ?? fehler}</p>
                    {!recht && (
                        <p className="mt-2 text-xs text-amber-700">
                            Fehlt die Migration <code>supabase/erp_steering.sql</code> (MIGRATIONS.md Nr. 23),
                            antwortet die Datenbank mit <code>PGRST202</code>. Der übrige Betrieb ist davon nicht betroffen.
                        </p>
                    )}
                </div>
            </div>
        );
    }
    if (leer) {
        return <p className="py-12 text-center text-sm text-slate-400">{leerText || 'Keine Daten.'}</p>;
    }
    return <>{children}</>;
};
